import CardActivationSuccessScreen from 'features/cardManagement/screens/cardActivation/CardActivationSuccessScreen/CardActivationSuccessScreen';
import React from 'react';

export default function CardActivationSuccessPage() {
  return <CardActivationSuccessScreen />;
}
